import { useParams } from "react-router-dom";
import { useEffect } from "react";
import i18n from "../i18n";
// import i18n from "./i18n"; // tumhara i18 config

const LocaleWrapper = ({ children }) => {
  const { lang } = useParams();

  // useEffect(() => {
  //   if (lang === "es") {
  //     i18n.changeLanguage("es");
  //   } else {
  //     i18n.changeLanguage("en");
  //   }
  // }, [lang]);

  return children;
};

export default LocaleWrapper;
